import PmrE2EProjectOrderlineModel from '../interfaces/pmr-e2e-project-orderline-model'
import { E2EProjectLineFlexTaskGroupItemModel } from '../interfaces/pmr-e2e-project-task-group-item-model'
import PmrE2EProjectTaskModel from '../interfaces/pmr-e2e-project-task-model'

interface options {
  projectTasks: PmrE2EProjectTaskModel[]
  selectedTasks: string[]
  rowData: PmrE2EProjectTaskModel | PmrE2EProjectOrderlineModel
}
export default function getParentFromSelectedTaskSiblings({
  projectTasks,
  selectedTasks,
  rowData,
}: options) {
  let getParentTaskFn: ((child: E2EProjectLineFlexTaskGroupItemModel) => boolean) | null = null
  let getSiblingsFn: ((task: E2EProjectLineFlexTaskGroupItemModel) => boolean) | null = null

  if ('e2EProjectLineFlexTaskIds' in rowData) {
    getParentTaskFn = (child: E2EProjectLineFlexTaskGroupItemModel) =>
      rowData.e2EProjectLineFlexTaskIds.includes(child.e2EProjectLineFlexTaskId)
    getSiblingsFn = task =>
      !rowData.e2EProjectLineFlexTaskIds.includes(task.e2EProjectLineFlexTaskId)
  } else if ('parentTaskId' in rowData) {
    getParentTaskFn = child => rowData.e2EProjectLineFlexTaskId === child.e2EProjectLineFlexTaskId
    getSiblingsFn = task =>
      rowData.parentTaskId === task.parentTaskId &&
      task.e2EProjectLineFlexTaskId !== rowData.e2EProjectLineFlexTaskId
  }

  if (getParentTaskFn === null) return
  if (getSiblingsFn === null) return

  const parentTasks = projectTasks.filter(task => task.taskChildren?.some(getParentTaskFn!))
  const siblings = parentTasks.flatMap(parent => parent.taskChildren).filter(getSiblingsFn!)

  if (!siblings.every(item => selectedTasks.includes(item.e2EProjectLineFlexTaskId))) return

  return parentTasks
}
